/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit PatientActions/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import ProfileActions from 'DesignSystem/ProfileActions/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function PatientActions({
  children,
  viewPath = "/App/Account/Content/Tasks/New/Content/Board/Content/Main/Board/Board/Content/Card/PatientActions"
  
}) {
let cardPatientIdValueData = fromData.useDataValue({ viewPath,
context: 'card',
path: 'patient._id',
})
let cardPatientPersonValueData = fromData.useDataValue({ viewPath,
context: 'card',
path: 'patient.person',
})
let dtSpaceMs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ms'
        })
  return (<React.Fragment
>
<ProfileActions
  viewPath={`${viewPath}/ProfileActions`}
 gap={dtSpaceMs}
 data="card.patient._id"
 patient_id={cardPatientIdValueData}
 data="card.patient.person"
 person={cardPatientPersonValueData}
/>
{children}
</React.Fragment>)
}